import { diaryHomeToDoPath } from "@/features/diaries/routes";
import { createFileRoute, redirect } from "@tanstack/react-router";

/** Diary root URL goes straight to the patient forms tab. */
export const Route = createFileRoute("/_app/diaries/$diaryId/")({
    component: () => null,
    beforeLoad: ({ params }) => {
        throw redirect({
            to: diaryHomeToDoPath,
            params: { diaryId: params.diaryId },
        });
    },
});
